import { useEffect, useState } from "react";
import { Sparkles, ShieldCheck } from "lucide-react";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Sections5";
import { FlightSearchForm } from "@/components/flights/FlightSearchForm";
import { fetchFlightMeta } from "@/lib/api";

export default function FlightSearchPage() {
    const [meta, setMeta] = useState(null);

    useEffect(() => {
        fetchFlightMeta().then(setMeta).catch(() => setMeta({ demo_mode: true, booking_enabled: false }));
    }, []);

    return (
        <div className="min-h-screen bg-cream" data-testid="flight-search-page">
            <Header />
            <section className="bg-navy text-cream relative overflow-hidden">
                <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-saffron/10 blur-3xl" />
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14 sm:py-20 relative">
                    <p className="font-script text-3xl sm:text-4xl text-gold">Har Safar, Ek Kahani</p>
                    <h1 className="mt-2 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-tight">
                        Flights, booked the <span className="text-saffron">GhumneChaley</span> way.
                    </h1>
                    <p className="mt-4 text-cream/80 text-base sm:text-lg max-w-2xl">
                        Search domestic and international flights, see the full fare upfront, and let our team
                        ticket your journey with the care we give every group trip.
                    </p>
                    <div className="mt-5 flex flex-wrap gap-4 text-xs text-cream/70">
                        <span className="flex items-center gap-1.5"><ShieldCheck className="h-4 w-4 text-gold" />Transparent fares, no hidden fees</span>
                        <span className="flex items-center gap-1.5"><Sparkles className="h-4 w-4 text-gold" />Human support on every booking</span>
                    </div>
                </div>
            </section>

            <main className="max-w-5xl mx-auto px-4 sm:px-6 -mt-2 pb-20">
                {meta?.demo_mode && (
                    <div className="mt-6 rounded-xl border border-gold/60 bg-gold/15 px-4 py-3 text-sm text-navy flex gap-2 items-start" data-testid="demo-mode-banner">
                        <Sparkles className="h-4 w-4 mt-0.5 text-saffron shrink-0" />
                        <span><b>Preview mode:</b> flight results currently show <b>demonstration data</b> while our
                            certified flight supplier integration is being finalised. Sample fares are not live offers and
                            online booking is disabled.</span>
                    </div>
                )}

                <div className="mt-6">
                    <FlightSearchForm />
                </div>
            </main>
            <Footer />
        </div>
    );
}
